export const UPDATE_GLOBAL_SPINNER = 'UPDATE_GLOBAL_SPINNER';
export const UPDATE_LOCAL_SPINNER = 'UPDATE_LOCAL_SPINNER';
